import React from "react";
import { motion } from "framer-motion";
import { siteSocialLinks } from "../../constants/socialLinks";

const navLinks = [
  { name: "Home", href: "#home" },
  { name: "About", href: "#about" },
  { name: "Services", href: "#services" },
  { name: "Testimonials", href: "#testimonials" },
  { name: "Blog", href: "#blog" },
  { name: "Contact", href: "#contact" }
];

export const Footer = () => {
  const scrollToSection = (href) => {
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <footer
      className="footer-gradient py-12 sm:py-16 relative z-20"
      data-testid="footer"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          {/* Logo */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
            className="mb-6"
          >
            <h3 className="font-serif text-2xl sm:text-3xl text-warm-brown">
              Counselling Cell
            </h3>
            <p className="font-sans text-warm-brown/70 mt-1">
              by Priya Ahuja
            </p>
          </motion.div>

          {/* Tagline */}
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.1 }}
            viewport={{ once: true }}
            className="font-serif text-lg text-warm-brown/80 mb-8"
          >
            Healing Minds, Transforming Lives
          </motion.p>

          {/* Nav Links */}
          <motion.nav
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            viewport={{ once: true }}
            className="flex flex-wrap justify-center gap-4 sm:gap-8 mb-8"
          >
            {navLinks.map((link) => (
              <a
                key={link.name}
                href={link.href}
                onClick={(e) => {
                  e.preventDefault();
                  scrollToSection(link.href);
                }}
                className="font-sans text-warm-brown/70 hover:text-warm-brown transition-colors text-sm sm:text-base"
                data-testid={`footer-link-${link.name.toLowerCase()}`}
              >
                {link.name}
              </a>
            ))}
          </motion.nav>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.25 }}
            viewport={{ once: true }}
            className="flex justify-center gap-4 mb-8"
          >
            {siteSocialLinks.map((social) => (
              <motion.a
                key={social.name}
                href={social.url}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={`${social.name} (opens in new tab)`}
                whileHover={{ scale: 1.1, y: -3 }}
                whileTap={{ scale: 0.95 }}
                className="w-12 h-12 rounded-full bg-warm-card border border-warm-rose/20 flex items-center justify-center text-warm-brown/70 hover:text-white transition-all duration-300"
                style={{
                  "--hover-bg": social.hoverColor,
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = social.hoverColor;
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = "";
                }}
                data-testid={`footer-social-${social.name.toLowerCase()}`}
              >
                {social.icon}
              </motion.a>
            ))}
          </motion.div>

          {/* Divider */}
          <div className="w-24 h-px bg-warm-brown/20 mx-auto mb-8" />

          {/* Copyright */}
          <motion.p
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            transition={{ duration: 0.6, delay: 0.3 }}
            viewport={{ once: true }}
            className="font-sans text-warm-brown/60 text-sm"
          >
            © 2026 Counselling Cell by Priya Ahuja. All rights reserved.
          </motion.p>

          <p className="mt-4 font-sans text-center text-sm text-warm-brown/60">
            Designed and built by Deeptanshu Sharma
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
